import { render, staticRenderFns } from "./campaign_add_widget_dialog.vue?vue&type=template&id=fe08a212&scoped=true"
import script from "./campaign_add_widget_dialog.vue?vue&type=script&lang=ts"
export * from "./campaign_add_widget_dialog.vue?vue&type=script&lang=ts"
import style0 from "./campaign_add_widget_dialog.vue?vue&type=style&index=0&id=fe08a212&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe08a212",
  null
  
)

export default component.exports